import { TranslationState } from './types'

export const DEFAULT_LANG = 'default'

export const initialState: TranslationState = {
  data: {
    locales: [],
    en: {},
    default: {},
    tags: {
      chat: [],
    },
  },
  ready: false,
}
